'use client';

import { c as _c } from "react/compiler-runtime";
import { type StaticImageData } from 'next/image';
import { RecommendationCard } from '@module/mdrt-org/shared/components/recommendation-card/recommendation-card';
import { ResourceTypeIcon } from '@module/mdrt-org/shared/components/resource-type-icon/resource-type-icon';
import { type ContentType } from '@module/mdrt-org/shared/utils/data/constants/content-type';
import { Player } from '@shared/ui-components/player/player';
import { type PlayerDefaultTranslations } from '@shared/ui-components/player/types/player-default-translations';
type PlayerClientProps = {
  cmsContent: PlayerDefaultTranslations;
  recommendation?: null | {
    authors: string[];
    contentType: ContentType | null | number | undefined;
    isExternal: boolean;
    thumbnail: {
      altText?: string;
      fallbackSrc?: StaticImageData | string;
      src?: string;
    };
    title: string;
    url: string;
  };
  recommendationContainerId?: string;
  src: string;
  srcType: string;
};
export const PlayerClient = t0 => {
  const $ = _c(8);
  const {
    cmsContent,
    recommendation,
    recommendationContainerId,
    src,
    srcType
  } = t0;
  let t1;
  if ($[0] !== recommendation) {
    t1 = recommendation ? {
      ...recommendation,
      contentTypeIcon: <ResourceTypeIcon contentType={recommendation.contentType} isExternal={recommendation.isExternal} />
    } : undefined;
    $[0] = recommendation;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const recommendationWithIcon = t1;
  let t2;
  if ($[2] !== cmsContent || $[3] !== recommendationContainerId || $[4] !== recommendationWithIcon || $[5] !== src || $[6] !== srcType) {
    t2 = <Player cmsContent={cmsContent} recommendation={recommendationWithIcon} RecommendationCard={RecommendationCard} recommendationContainerId={recommendationContainerId} src={src} srcType={srcType} />;
    $[2] = cmsContent;
    $[3] = recommendationContainerId;
    $[4] = recommendationWithIcon;
    $[5] = src;
    $[6] = srcType;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};